import { render, staticRenderFns } from "./WPBuilder.vue?vue&type=template&id=0fd86e04&scoped=true&"
import script from "./WPBuilder.vue?vue&type=script&lang=js&"
export * from "./WPBuilder.vue?vue&type=script&lang=js&"
import style0 from "./WPBuilder.vue?vue&type=style&index=0&id=0fd86e04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd86e04",
  null
  
)

export default component.exports